import React from "react";
import { motion } from "framer-motion";

const Story = () => {
  return (
    <section
      id="story"
      className="relative py-32 md:py-44 bg-[#FAF5EC] overflow-hidden"
      data-testid="story-section"
    >
      <div className="max-w-screen-xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2 }}
        >
          <p className="text-[11px] uppercase tracking-[0.4em] text-[#B8954C] mb-6">
            Povestea ELENUIT
          </p>
          <h2 className="font-serif text-4xl md:text-6xl font-light text-[#1A1612] leading-[1.1] mb-8" data-testid="story-title">
            Eleganța născută din liniștea nopții.
          </h2>
          <div className="sep-line max-w-xs mx-auto mb-8">
            <span className="diamond" />
          </div>
          <p className="text-base md:text-lg text-[#6E665A] font-light leading-[1.9] max-w-2xl mx-auto mb-10" data-testid="story-lead">
            Există momente în viață care nu se grăbesc. Momente care cer liniște pentru a fi savurate pe deplin: o cină liniștită alături de persoana iubită, o discuție profundă cu un prieten vechi la apus, sau pur și simplu acele clipe de introspecție de la finalul unei zile lungi.
          </p>
          <p className="font-serif italic text-xl md:text-2xl text-[#1A1612] tracking-wide" data-testid="story-tagline">
            Sub lună, fiecare clipă strălucește.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Story;
